export default __webpack_public_path__ + "static/media/amazon-pay.99f9f038.png";